interface ComputerIconProps {
  width?: string;
  height?: string;
}

const ComputerIcon: React.FC<ComputerIconProps> = ({ width = "24px", height = "24px" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.152832 18V16H25.5139V18H0.152832ZM3.61117 15C2.97714 15 2.43437 14.8042 1.98287 14.4125C1.53136 14.0208 1.30561 13.55 1.30561 13V2C1.30561 1.45 1.53136 0.979167 1.98287 0.5875C2.43437 0.195833 2.97714 0 3.61117 0H22.0556C22.6896 0 23.2324 0.195833 23.6839 0.5875C24.1354 0.979167 24.3612 1.45 24.3612 2V13C24.3612 13.55 24.1354 14.0208 23.6839 14.4125C23.2324 14.8042 22.6896 15 22.0556 15H3.61117ZM3.61117 13H22.0556V2H3.61117V13Z" fill="#1D1F22"/>
    </svg>
  );
};

export default ComputerIcon;
